export const BUY = 'Buy'
export const SELL = 'Sell'
export const BOTH = 'Both'